/* tslint:disable */
/* eslint-disable */
import { AnfrageDisplayModel as AceXFoundPortalCoreCaqModelsAnfrageDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/anfrage-display-model';
import { AusschreibungDisplayModel as AceXFoundPortalCoreCaqModelsAusschreibungDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/ausschreibung-display-model';
import { PhaseDisplayModel as AceXFoundPortalCoreCaqModelsPhaseDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/phase-display-model';
import { GlobalEnumsAceBewertung as AceXFoundPortalCoreEntitiesGlobalEnumsAceBewertung } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-bewertung';
import { AceGutachtenAceGutachtenEnumsAceGutachtenStatuscode as AceXFoundPortalCoreEntitiesAceGutachtenAceGutachtenEnumsAceGutachtenStatuscode } from '../../../../../../ace/xFound/Portal/Core/Entities/ace-gutachten-ace-gutachten-enums-ace-gutachten-statuscode';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..
import { AnfrageDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsAnfrageDisplayModelFormGroup } from '@/api/model-index';
import { AusschreibungDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsAusschreibungDisplayModelFormGroup } from '@/api/model-index';
import { PhaseDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsPhaseDisplayModelFormGroup } from '@/api/model-index';

export interface IGutachtenDisplayModel {
  anfrage?: AceXFoundPortalCoreCaqModelsAnfrageDisplayModel;
  ausschreibung?: AceXFoundPortalCoreCaqModelsAusschreibungDisplayModel;
  bewertung?: AceXFoundPortalCoreEntitiesGlobalEnumsAceBewertung;
  ergebnis?: null | string;
  gutachtenAbgegebenAm?: null | string;
  gutachtenId?: null | string;
  gutachtenPhase?: AceXFoundPortalCoreCaqModelsPhaseDisplayModel;
  inhaltlicheZusammenfassung?: null | string;
  staerkenSchwaechenAnalyse?: null | string;
  statuscode?: AceXFoundPortalCoreEntitiesAceGutachtenAceGutachtenEnumsAceGutachtenStatuscode;
  titel?: null | string;
}
export class GutachtenDisplayModel extends BaseModel implements IGutachtenDisplayModel {
  anfrage?: AceXFoundPortalCoreCaqModelsAnfrageDisplayModel;
  ausschreibung?: AceXFoundPortalCoreCaqModelsAusschreibungDisplayModel;
  bewertung?: AceXFoundPortalCoreEntitiesGlobalEnumsAceBewertung;
  ergebnis?: null | string;
  gutachtenAbgegebenAm?: null | string;
  gutachtenId?: null | string;
  gutachtenPhase?: AceXFoundPortalCoreCaqModelsPhaseDisplayModel;
  inhaltlicheZusammenfassung?: null | string;
  staerkenSchwaechenAnalyse?: null | string;
  statuscode?: AceXFoundPortalCoreEntitiesAceGutachtenAceGutachtenEnumsAceGutachtenStatuscode;
  titel?: null | string;
}
class BaseGutachtenDisplayModelFormGroup extends FormGroup {
  private static _instance: GutachtenDisplayModelFormGroup;
  
  public static get Instance(): GutachtenDisplayModelFormGroup {
    this._instance = new GutachtenDisplayModelFormGroup({
      anfrage: AceXFoundPortalCoreCaqModelsAnfrageDisplayModelFormGroup.Instance,
      ausschreibung: AceXFoundPortalCoreCaqModelsAusschreibungDisplayModelFormGroup.Instance,
      bewertung: new FormControl(null),
      ergebnis: new FormControl(null),
      gutachtenAbgegebenAm: new FormControl(null),
      gutachtenId: new FormControl(null),
      gutachtenPhase: AceXFoundPortalCoreCaqModelsPhaseDisplayModelFormGroup.Instance,
      inhaltlicheZusammenfassung: new FormControl(null),
      staerkenSchwaechenAnalyse: new FormControl(null),
      statuscode: new FormControl(null),
      titel: new FormControl(null),
    });

    return this._instance;
  }
}


export class GutachtenDisplayModelFormGroup extends BaseGutachtenDisplayModelFormGroup {
  public get Anfrage(): AceXFoundPortalCoreCaqModelsAnfrageDisplayModelFormGroup {
    return this.controls["anfrage"] as AceXFoundPortalCoreCaqModelsAnfrageDisplayModelFormGroup;
  }
  public get Ausschreibung(): AceXFoundPortalCoreCaqModelsAusschreibungDisplayModelFormGroup {
    return this.controls["ausschreibung"] as AceXFoundPortalCoreCaqModelsAusschreibungDisplayModelFormGroup;
  }
  public get Bewertung(): FormControl {
    return this.controls["bewertung"] as FormControl;
  }
  public get Ergebnis(): FormControl {
    return this.controls["ergebnis"] as FormControl;
  }
  public get GutachtenAbgegebenAm(): FormControl {
    return this.controls["gutachtenAbgegebenAm"] as FormControl;
  }
  public get GutachtenId(): FormControl {
    return this.controls["gutachtenId"] as FormControl;
  }
  public get GutachtenPhase(): AceXFoundPortalCoreCaqModelsPhaseDisplayModelFormGroup {
    return this.controls["gutachtenPhase"] as AceXFoundPortalCoreCaqModelsPhaseDisplayModelFormGroup;
  }
  public get InhaltlicheZusammenfassung(): FormControl {
    return this.controls["inhaltlicheZusammenfassung"] as FormControl;
  }
  public get StaerkenSchwaechenAnalyse(): FormControl {
    return this.controls["staerkenSchwaechenAnalyse"] as FormControl;
  }
  public get Statuscode(): FormControl {
    return this.controls["statuscode"] as FormControl;
  }
  public get Titel(): FormControl {
    return this.controls["titel"] as FormControl;
  }
  

}

export module GutachtenDisplayModelForm
  {
    export class FormFields
    {
      static _anfrage: string = "anfrage";
      static _ausschreibung: string = "ausschreibung";
      static _bewertung: string = "bewertung";
      static _ergebnis: string = "ergebnis";
      static _gutachtenAbgegebenAm: string = "gutachtenAbgegebenAm";
      static _gutachtenId: string = "gutachtenId";
      static _gutachtenPhase: string = "gutachtenPhase";
      static _inhaltlicheZusammenfassung: string = "inhaltlicheZusammenfassung";
      static _staerkenSchwaechenAnalyse: string = "staerkenSchwaechenAnalyse";
      static _statuscode: string = "statuscode";
      static _titel: string = "titel";
    }
  }

